import { render, staticRenderFns } from "./inventory-product-filter.vue?vue&type=template&id=754440de&scoped=true&"
import script from "./inventory-product-filter.vue?vue&type=script&lang=js&"
export * from "./inventory-product-filter.vue?vue&type=script&lang=js&"
import style0 from "./inventory-product-filter.vue?vue&type=style&index=0&id=754440de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754440de",
  null
  
)

export default component.exports